import { render } from "./ed-molecule-login-form.vue?vue&type=template&id=078ac8d7"
import script from "./ed-molecule-login-form.vue?vue&type=script&lang=js"
export * from "./ed-molecule-login-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__